export default __webpack_public_path__ + "static/media/invBack3Opacity.bcc54a6e.png";